export class MailSignatureFiles {
  mailId: number;
  objet: string;
  serviceId: number;
  serviceLabel: string;
  documentName: string;
  name: string;
  extension: string;
  id: number;
  version: number;
}
